import React from 'react';
import { observer } from 'mobx-react';
import { Col, Tooltip } from 'antd';
import { columnOption } from '../columnOption';
import cx from 'classnames';
import { useDashboardFinancesRollVolumes, useUiUnitTypeValue } from '../../../hooks';
import { UnitTypeValues, getCatalogsOriginalUnitTypeTitle } from '../../../middleware';
import { numberToStringWithSeparator, showOriginalUnitByType, stringCount } from '../../../instruments';
import { ITrField, tF } from '../../../translate';
import { Catcher, LoadingApiByIds } from '../../../Components';
import Styles from '../m_dashboarStyles.less';

interface IInfoCard {
    children?: never;
}

export const FinancesInfoCard: React.FC<IInfoCard> = observer(() => {
    const originalUnits = useDashboardFinancesRollVolumes();
    const unitTypeValue = useUiUnitTypeValue();
    const unitTypeTitle = getCatalogsOriginalUnitTypeTitle(unitTypeValue);
    const unitTypeTitleTr = unitTypeTitle ? tF(unitTypeTitle as ITrField) : '';
    const title = `${tF('Usage')} ${unitTypeTitleTr}`;

    const subValue =
        unitTypeValue === UnitTypeValues.SMS
            ? `${originalUnits} ${unitTypeTitleTr}`
            : showOriginalUnitByType(originalUnits, unitTypeValue, 2);
    const subtitle = originalUnits === undefined ? '' : ` (${subValue} ${tF('of unassigned')} ${unitTypeTitleTr})`;

    let value;

    if (unitTypeValue === UnitTypeValues.DATA) {
        value = showOriginalUnitByType(originalUnits, unitTypeValue, 2);
    } else if (unitTypeValue === UnitTypeValues.SMS) {
        value = `${originalUnits} ${unitTypeTitleTr}`;
    } else if (unitTypeValue === UnitTypeValues.VOICE) {
        value = originalUnits
            ? `${numberToStringWithSeparator(Math.floor(+originalUnits / 60))} min ${+originalUnits % 60} sec`
            : '0 sec';
    } else {
        value = showOriginalUnitByType(originalUnits, unitTypeValue, 2);
    }

    return (
        <Catcher>
            <Col className={Styles.cardPlace} {...columnOption.financesInfoCard}>
                <div className={cx(Styles.infoCard, Styles.financesCard)}>
                    <LoadingApiByIds idSpinners={['GET_FINANCE_ROLL']} />
                    <div className={Styles.info}>
                        <div className={Styles.title}>
                            {title}
                            <Tooltip title={`${stringCount(originalUnits)} ${unitTypeValue}`} placement="topLeft">
                                <span>{subtitle}</span>
                            </Tooltip>
                        </div>
                        <div className={cx(Styles.value, Styles.financesInfoCardValue)}>
                            <Tooltip title={`${stringCount(originalUnits)} ${unitTypeValue}`}>
                                <span>{value}</span>
                            </Tooltip>
                        </div>
                    </div>
                </div>
            </Col>
        </Catcher>
    );
});
